/* Rekover : « le fil rouge ».
   Après l'animation d'accueil, le corps reste dessiné en traits fins, à moitié invisible, et accompagne toute la page
   (par-dessus le contenu, les clics passent à travers). À chaque section, il se tourne vers la partie du corps dont
   la section parle, et cette partie devient argent poli, de bas en haut ; en passant à la suivante, elle redevient
   un simple dessin. Tout en bas, au-dessus du mot REKOVER, il se décompose en éclats, se recompose et devient
   entièrement argenté. Un petit rail sur le côté montre le parcours. */
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

(function () {
  if (window.__rkCompanion) return; window.__rkCompanion = 1;
  const hero = document.querySelector('[data-rkb]');
  const heroTrack = hero && hero.querySelector('.rkb__track');
  const main = document.querySelector('main') || document.body;

  /* le mot de la fin, en métal liquide (rekover-liquid.js) */
  const endSec = document.createElement('section');
  endSec.className = 'rk-companion-end';
  endSec.style.cssText = 'position:relative;min-height:100vh;display:flex;flex-direction:column;justify-content:flex-end;align-items:center;padding:0 16px 5vh;overflow:hidden;pointer-events:none';
  const word = document.createElement('p');
  word.setAttribute('data-liquid', ''); word.textContent = 'REKOVER';
  word.style.cssText = "margin:0;font:800 clamp(64px,17vw,300px)/.86 'Inter',sans-serif;letter-spacing:-.035em;text-transform:uppercase;white-space:nowrap;color:#6F777F;padding:.04em .03em .1em";
  endSec.appendChild(word);
  main.appendChild(endSec);

  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;


  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const sm = (a, b, x) => { const t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
  const lerp = (a, b, t) => a + (b - a) * t;
  const TAU = Math.PI * 2;
  const touch = matchMedia('(pointer: coarse)').matches;
  const small = touch || innerWidth < 760;
  // téléphone seulement (pas l'iPad) : le corps passe dans une petite carte
  const phone = Math.min(screen.width, screen.height) < 600 || innerWidth < 600;
  // les étiquettes dans la langue du site (FR par défaut)
  const LANG = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  const TR = {
    nl: { 'Jambes': 'Benen', 'Dos': 'Rug', 'Nuque & épaules': 'Nek & schouders', 'Bras': 'Armen', 'Abdos & buste': 'Buik & borst', 'Mollets': 'Kuiten' },
    en: { 'Jambes': 'Legs', 'Dos': 'Back', 'Nuque & épaules': 'Neck & shoulders', 'Bras': 'Arms', 'Abdos & buste': 'Abs & chest', 'Mollets': 'Calves' }
  };
  const L = (txt) => (TR[LANG] && TR[LANG][txt]) || txt;

  let renderer;
  try { renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' }); } catch (e) { return; }
  renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 2));
  renderer.setClearColor(0x000000, 0);
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;
  const cv = renderer.domElement;
  cv.className = 'rk-companion'; cv.setAttribute('aria-hidden', 'true');
  const CSS_FULL = 'position:fixed;inset:0;width:100%;height:100%;z-index:30;pointer-events:none;opacity:0;transition:opacity .5s';
  // sur téléphone : le corps vit dans une petite carte en verre, en bas à droite, au lieu de passer devant le contenu
  const MW = 165, MH = 272;
  const CSS_MINI = 'position:fixed;left:auto;top:auto;right:calc(12px + env(safe-area-inset-right,0px));bottom:calc(14px + env(safe-area-inset-bottom,0px));width:' + MW + 'px;height:' + MH + 'px;z-index:30;pointer-events:auto;touch-action:pan-y;opacity:0;transition:opacity .5s,transform .35s ease;border-radius:20px;background:linear-gradient(160deg,rgba(255,255,255,.86),rgba(236,239,242,.78));-webkit-backdrop-filter:blur(12px) saturate(1.2);backdrop-filter:blur(12px) saturate(1.2);border:1px solid rgba(29,33,37,.10);box-shadow:0 14px 34px -14px rgba(29,33,37,.45),inset 0 1px 0 rgba(255,255,255,.9)';
  let mini = phone;
  cv.style.cssText = mini ? CSS_MINI : CSS_FULL;
  document.body.appendChild(cv);

  /* on peut glisser la carte vers la droite pour la ranger ; un petit onglet au bord la fait revenir */
  let dismissed = false;
  try { dismissed = sessionStorage.getItem('rkMiniOff') === '1'; } catch (e) {}
  const OFF = 'translateX(calc(100% + 40px))';
  const pull = document.createElement('button');
  pull.type = 'button'; pull.className = 'rk-companion-pull';
  pull.setAttribute('aria-label', ({ nl: 'Figuur tonen', en: 'Show figure' })[(document.documentElement.lang || 'fr').slice(0, 2)] || 'Afficher le personnage');
  pull.style.cssText = "position:fixed;right:0;bottom:calc(14px + " + Math.round(MH / 2 - 28) + "px + env(safe-area-inset-bottom,0px));z-index:31;width:26px;height:56px;padding:0;border:1px solid rgba(29,33,37,.12);border-right:0;border-radius:14px 0 0 14px;background:rgba(255,255,255,.9);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);box-shadow:0 8px 20px -10px rgba(29,33,37,.45);color:#1D2125;font:600 18px/1 'Inter',sans-serif;display:none;align-items:center;justify-content:center;cursor:pointer";
  pull.textContent = '‹';
  document.body.appendChild(pull);
  function setDismissed(v) {
    dismissed = v;
    try { sessionStorage.setItem('rkMiniOff', v ? '1' : '0'); } catch (e) {}
    if (mini) { cv.style.transition = ''; cv.style.transform = v ? OFF : ''; }
  }
  pull.addEventListener('click', () => setDismissed(false));
  if (mini && dismissed) cv.style.transform = OFF;
  let tx0 = 0, ty0 = 0, tdx = 0, horiz = null;
  cv.addEventListener('touchstart', (e) => { if (!mini) return; const p = e.touches[0]; tx0 = p.clientX; ty0 = p.clientY; tdx = 0; horiz = null; }, { passive: true });
  cv.addEventListener('touchmove', (e) => {
    if (!mini) return;
    const p = e.touches[0], dx = p.clientX - tx0, dy = p.clientY - ty0;
    if (horiz === null && Math.abs(dx) + Math.abs(dy) > 8) horiz = Math.abs(dx) > Math.abs(dy);
    if (!horiz) return;
    tdx = Math.max(0, dx); cv.style.transition = 'none'; cv.style.transform = 'translateX(' + tdx + 'px)';
  }, { passive: true });
  cv.addEventListener('touchend', () => { if (!mini || !horiz) return; setDismissed(tdx > 50); });

  /* l'étiquette qui nomme la zone travaillée */
  const tag = document.createElement('div');
  tag.setAttribute('aria-hidden', 'true');
  tag.style.cssText = "position:fixed;left:0;top:0;z-index:31;pointer-events:none;display:flex;align-items:center;gap:10px;opacity:0;transition:opacity .35s;font:600 11px/1 'Inter',sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#1D2125;white-space:nowrap";
  tag.innerHTML = '<i style="display:block;width:44px;height:1px;background:linear-gradient(90deg,rgba(29,33,37,0),#1D2125)"></i><span style="padding:8px 12px;border-radius:999px;background:rgba(255,255,255,.88);border:1px solid #DDE1E6;box-shadow:0 6px 18px -8px rgba(29,33,37,.35)"></span>';
  const tagText = tag.querySelector('span');
  document.body.appendChild(tag);

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(30, 1, 0.05, 30);
  camera.position.set(0, 0, 4);
  const HALF_H = 4 * Math.tan(THREE.MathUtils.degToRad(15));
  scene.environment = new THREE.PMREMGenerator(renderer).fromScene(new RoomEnvironment(renderer), 0.03).texture;
  const key = new THREE.DirectionalLight(0xffffff, 1.2); key.position.set(2, 4, 3); scene.add(key);
  const rim = new THREE.DirectionalLight(0xe8eef5, 1.0); rim.position.set(-3, 2, -4); scene.add(rim);

  /* matière : un trait. Le contour et les reliefs des muscles sont dessinés (plus la surface est de biais, plus le trait est marqué),
     l'intérieur reste presque transparent. La zone travaillée se remplit de rouge, puis une onde argentée la répare. */
  const U = { uT: { value: 0 }, uHL: { value: new Array(8).fill(0) }, uHeal: { value: 0 }, uLo: { value: new Array(8).fill(0) }, uHi: { value: new Array(8).fill(1.7) }, uOp: { value: 0 }, uEx: { value: 0 }, uChrome: { value: 0 }, uInk: { value: 1 }, uS: { value: new Array(8).fill(0) } };
  // la fin : le corps se décompose en éclats puis se recompose (même déplacement pour toutes les couches)
  const EXPLODE = `
      // chaque petit triangle part comme un éclat, en rétrécissant, puis revient à sa place
      vec3 cell = floor(aCenter * 7.0) + 0.5;
      float hh = fract(sin(dot(cell, vec3(12.9898, 78.233, 37.719))) * 43758.5453);
      float hf = fract(sin(dot(aCenter, vec3(39.3468, 11.135, 83.155))) * 24634.6345);
      vec3 dir = normalize(aCenter - vec3(0.0, 0.9, 0.0) + vec3(0.0001));
      vec3 pos = aCenter + (position - aCenter) * (1.0 - 0.45 * uEx) + (dir * (0.5 + 0.7 * hh + 0.3 * hf) + vec3(0.0, 0.35 * (hf - 0.4), 0.0)) * uEx * 0.28;`;
  const matMus = new THREE.ShaderMaterial({
    uniforms: U, transparent: true, depthWrite: false, depthFunc: THREE.LessEqualDepth,
    vertexShader: `
      attribute float _zone; attribute vec3 aCenter; uniform float uEx; varying float vZone; varying vec3 vP, vN, vV;
      void main() {
        vZone = _zone; vP = position;${EXPLODE}
        vec4 mv = modelViewMatrix * vec4(pos, 1.0);
        vN = normalize(normalMatrix * normal); vV = normalize(-mv.xyz);
        gl_Position = projectionMatrix * mv;
      }`,
    fragmentShader: `
      uniform float uT, uOp, uChrome, uEx, uInk; uniform float uS[8], uLo[8], uHi[8], uHL[8];
      varying float vZone; varying vec3 vP, vN, vV;
      void main() {
        int zi = int(vZone + 0.5);
        float ndv = abs(dot(normalize(vN), normalize(vV)));
        // trait doux : on lisse la transition pour éviter le scintillement sur les petits reliefs
        float rim = smoothstep(0.25, 1.0, 1.0 - ndv); rim *= rim;
        // là où le relief change trop vite pour l'écran (petits muscles, mains), on adoucit : plus de points qui grésillent
        float busy = length(fwidth(normalize(vN)));
        rim *= 1.0 - smoothstep(0.25, 0.9, busy);
        // la partie argentée (calculée comme dans la matière argent) : le trait s'efface là où elle est
        float sv = max(uS[zi], uChrome);
        float front = mix(uLo[zi] - 0.04, uHi[zi] + 0.04, sv);
        float silv = smoothstep(-0.03, 0.03, front - vP.y) * step(0.001, sv);
        vec3 ink = vec3(0.16, 0.19, 0.22), silver = vec3(0.55, 0.6, 0.66);
        vec3 col = mix(ink, silver, 0.35 * (1.0 - rim));
        col = mix(col, vec3(0.5, 0.55, 0.6) * (0.7 + 0.6 * ndv), uEx);
        float a = (rim * 0.42 * uInk + 0.03 * uInk) * (1.0 - silv) + uEx * 0.75;
        // la zone de la section arrive en rouge (la tension), puis l'onde argentée la recouvre
        float heat = uHL[zi] * (1.0 - silv) * (1.0 - uEx);
        vec3 red = vec3(0.78, 0.1, 0.09) * (0.55 + 0.5 * ndv) + vec3(0.25, 0.05, 0.04) * rim;
        col = mix(col, red, heat);
        a = mix(a, 0.68 + 0.3 * rim, heat);
        gl_FragColor = vec4(col, clamp(a, 0.0, 1.0) * uOp);
      }`
  });
  // avant le trait, on écrit seulement la profondeur : seules les surfaces de devant sont dessinées (pas d'effet « rayons X »)
  const matDepth = new THREE.ShaderMaterial({ uniforms: U, colorWrite: false, polygonOffset: true, polygonOffsetFactor: 1, polygonOffsetUnits: 2,
    vertexShader: `attribute vec3 aCenter; uniform float uEx; void main() {${EXPLODE}
 vec4 mv = modelViewMatrix * vec4(pos, 1.0); gl_Position = projectionMatrix * mv; }`,
    fragmentShader: 'void main() { gl_FragColor = vec4(0.0); }' });
  // la peau d'argent poli qui apparaît à la toute fin
  const matChrome = new THREE.MeshPhysicalMaterial({ color: 0xf0f2f4, metalness: 1, roughness: 0.17, clearcoat: 0.6, clearcoatRoughness: 0.14, envMapIntensity: 1.3, transparent: true });
  matChrome.onBeforeCompile = (sh) => {
    sh.uniforms.uEx = U.uEx; sh.uniforms.uChrome = U.uChrome; sh.uniforms.uOp = U.uOp; sh.uniforms.uS = U.uS; sh.uniforms.uLo = U.uLo; sh.uniforms.uHi = U.uHi;
    sh.vertexShader = 'attribute vec3 aCenter;\nattribute float _zone;\nuniform float uEx;\nvarying float vZone;\nvarying vec3 vP;\n' + sh.vertexShader.replace('#include <begin_vertex>', '#include <begin_vertex>' + EXPLODE + '\ntransformed = pos; vZone = _zone; vP = position;');
    // la partie montrée devient argent de bas en haut, avec un liseré lumineux sur le front
    sh.fragmentShader = 'float rkVis = 1.0;\nuniform float uChrome, uOp;\nuniform float uS[8];\nuniform float uLo[8];\nuniform float uHi[8];\nvarying float vZone;\nvarying vec3 vP;\n' + sh.fragmentShader
      .replace('#include <emissivemap_fragment>', `#include <emissivemap_fragment>
        int zi = int(vZone + 0.5);
        float sv = max(uS[zi], uChrome);
        float front = mix(uLo[zi] - 0.04, uHi[zi] + 0.04, sv);
        float vis = smoothstep(-0.03, 0.03, front - vP.y) * step(0.001, sv);
        if (vis < 0.01) discard;
        float rimL = exp(-pow((front - vP.y) / 0.02, 2.0)) * step(sv, 0.999);
        rkVis = vis;
        totalEmissiveRadiance += vec3(0.95, 0.97, 1.0) * rimL * 1.2;`)
      .replace('#include <dithering_fragment>', '#include <dithering_fragment>\n  { float ndv = abs(dot(normalize(vNormal), normalize(vViewPosition))); gl_FragColor.rgb *= mix(0.34, 1.02, smoothstep(0.0, 0.9, ndv)); }\ngl_FragColor.a *= uOp * rkVis;');
  };
  function addPart(src) {
    // chaque triangle a ses propres sommets et connaît son centre : il peut s'envoler sans déformer ses voisins
    const geo = src.index ? src.toNonIndexed() : src, P = geo.getAttribute('position'), C = new Float32Array(P.count * 3);
    for (let i = 0; i < P.count; i += 3) for (let a = 0; a < 3; a++) {
      const v = (P.getComponent(i, a) + P.getComponent(i + 1, a) + P.getComponent(i + 2, a)) / 3;
      C[i * 3 + a] = v; C[(i + 1) * 3 + a] = v; C[(i + 2) * 3 + a] = v;
    }
    geo.setAttribute('aCenter', new THREE.BufferAttribute(C, 3));
    const d = new THREE.Mesh(geo, matDepth); d.renderOrder = 0;
    const m = new THREE.Mesh(geo, matMus); m.renderOrder = 1;
    const c = new THREE.Mesh(geo, matChrome); c.renderOrder = 2;
    body.add(d); body.add(m); body.add(c);
  }

  async function loadModel(src) {
    const buf = await (await fetch(src)).arrayBuffer(), u8 = new Uint8Array(buf);
    if (u8[0] !== 0x89 || u8[1] !== 0x50) return buf;
    const dv = new DataView(buf); let o = 8, w = 0, h = 0, ct = 2; const idat = [];
    while (o < u8.length) {
      const len = dv.getUint32(o), type = String.fromCharCode(u8[o + 4], u8[o + 5], u8[o + 6], u8[o + 7]);
      if (type === 'IHDR') { w = dv.getUint32(o + 8); h = dv.getUint32(o + 12); ct = u8[o + 17]; }
      else if (type === 'IDAT') idat.push(u8.subarray(o + 8, o + 8 + len));
      else if (type === 'IEND') break;
      o += 12 + len;
    }
    const z = await new Response(new Blob(idat).stream().pipeThrough(new DecompressionStream('deflate'))).arrayBuffer();
    const src8 = new Uint8Array(z), bpp = ct === 6 ? 4 : 3, stride = w * bpp, out = new Uint8Array(stride * h);
    for (let y = 0; y < h; y++) {
      const f = src8[y * (stride + 1)], row = y * stride, inp = y * (stride + 1) + 1;
      for (let x = 0; x < stride; x++) {
        const a = x >= bpp ? out[row + x - bpp] : 0, b = y ? out[row - stride + x] : 0, c = x >= bpp && y ? out[row - stride + x - bpp] : 0;
        let v = src8[inp + x];
        if (f === 1) v += a; else if (f === 2) v += b; else if (f === 3) v += (a + b) >> 1;
        else if (f === 4) { const p = a + b - c, pa = Math.abs(p - a), pb = Math.abs(p - b), pc = Math.abs(p - c); v += pa <= pb && pa <= pc ? a : pb <= pc ? b : c; }
        out[row + x] = v & 255;
      }
    }
    let data = out;
    if (bpp === 4) { data = new Uint8Array(w * h * 3); for (let i = 0, j = 0; i < out.length; i += 4) { data[j++] = out[i]; data[j++] = out[i + 1]; data[j++] = out[i + 2]; } }
    const n = data[0] | data[1] << 8 | data[2] << 16 | data[3] << 24;
    return data.slice(4, 4 + n).buffer;
  }
  /* le corps : muscles du modèle + tête et ventre (abdos, nombril) comme à l'accueil */
  const body = new THREE.Group(); body.visible = false; scene.add(body);
  const zoneC = [];                                                      // centre de chaque zone (pour cadrer et placer l'étiquette)
  const url = hero && hero.getAttribute('data-model');
  if (url) loadModel(url).then((buf) => new Promise((ok, ko) => new GLTFLoader().parse(buf, '', ok, ko))).then((gltf) => {
    let skin = null, mus = null;
    gltf.scene.traverse((o) => { if (!o.isMesh) return; if (o.name.indexOf('skin') === 0 || (o.parent && o.parent.name === 'skin')) skin = o; else mus = o; });
    if (!mus || !skin) return;
    mus.geometry.computeVertexNormals(); skin.geometry.computeVertexNormals();
    const z = mus.geometry.getAttribute('_zone'), p = mus.geometry.getAttribute('position');
    const acc = Array.from({ length: 8 }, () => [0, 0, 0, 0]), lo = new Array(8).fill(9), hi = new Array(8).fill(-9);
    for (let i = 0; i < p.count; i++) { const k = Math.round(z.getX(i)); acc[k][0] += Math.abs(p.getX(i)); acc[k][1] += p.getY(i); acc[k][2] += p.getZ(i); acc[k][3]++; lo[k] = Math.min(lo[k], p.getY(i)); hi[k] = Math.max(hi[k], p.getY(i)); }
    for (let k = 0; k < 8; k++) { if (acc[k][3]) { zoneC[k] = [acc[k][0] / acc[k][3], acc[k][1] / acc[k][3], acc[k][2] / acc[k][3]]; U.uLo.value[k] = lo[k]; U.uHi.value[k] = hi[k]; } }
    addPart(mus.geometry);
    // tête (zone 7) et ventre (zone 6, avec la poitrine)
    const sp = skin.geometry.getAttribute('position'), si = skin.geometry.index, keep = [];
    for (let t = 0; t < si.count; t += 3) { const a = si.getX(t), b = si.getX(t + 1), c = si.getX(t + 2); if (sp.getY(a) > 1.5 && sp.getY(b) > 1.5 && sp.getY(c) > 1.5) keep.push(a, b, c); }
    const hg = new THREE.BufferGeometry(); hg.setAttribute('position', sp); hg.setAttribute('normal', skin.geometry.getAttribute('normal')); hg.setIndex(keep);
    hg.setAttribute('_zone', new THREE.BufferAttribute(new Float32Array(sp.count).fill(7), 1));
    addPart(hg);
    const bg = bellyGeometry(skin);
    bg.setAttribute('_zone', new THREE.BufferAttribute(new Float32Array(bg.getAttribute('position').count).fill(6), 1));
    U.uLo.value[6] = Math.min(U.uLo.value[6], 0.92);
    addPart(bg);
    zoneC[6] = [0, 1.08, 0.1];
    // le bas du ventre, lisse comme un mannequin : pas de sexe
    const pg = pelvisGeometry(skin);
    pg.setAttribute('_zone', new THREE.BufferAttribute(new Float32Array(pg.getAttribute('position').count).fill(2), 1));
    addPart(pg);
    body.visible = true;
  }).catch(() => {});

  function pelvisGeometry(skin) {
    // une plaque lisse en triangle (pli de l'aine) qui prend le relief de la peau autour et couvre l'entrejambe
    const pos = skin.geometry.getAttribute('position');
    const NX = 53, NY = 45, x0 = -0.14, x1 = 0.14, y0 = 0.72, y1 = 0.99, dx = (x1 - x0) / (NX - 1), dy = (y1 - y0) / (NY - 1);
    const Hm = new Float32Array(NX * NY).fill(-1), fix = new Uint8Array(NX * NY);
    for (let i = 0; i < pos.count; i++) {
      const x = pos.getX(i), y = pos.getY(i), z = pos.getZ(i);
      if (z < -0.02 || x < x0 || x > x1 || y < y0 || y > y1) continue;
      const k = Math.round((y - y0) / dy) * NX + Math.round((x - x0) / dx);
      if (z > Hm[k]) Hm[k] = z;
    }
    for (let Y = 0; Y < NY; Y++) for (let X = 0; X < NX; X++) {
      const k = Y * NX + X, x = x0 + X * dx, y = y0 + Y * dy;
      if (Hm[k] > -0.5 && !(Math.abs(x) < 0.07 && y < 0.92)) fix[k] = 1; else Hm[k] = 0.04;
    }
    for (let it = 0; it < 500; it++) for (let Y = 1; Y < NY - 1; Y++) for (let X = 1; X < NX - 1; X++) { const k = Y * NX + X; if (!fix[k]) Hm[k] = 0.25 * (Hm[k - 1] + Hm[k + 1] + Hm[k - NX] + Hm[k + NX]); }
    for (let it = 0; it < 6; it++) { const c = Hm.slice(); for (let Y = 1; Y < NY - 1; Y++) for (let X = 1; X < NX - 1; X++) { const k = Y * NX + X; Hm[k] = (4 * c[k] + c[k - 1] + c[k + 1] + c[k - NX] + c[k + NX]) / 8; } }
    const edge = (x, y) => (0.022 + 0.085 * clamp((y - 0.76) / 0.2, 0, 1)) - Math.abs(x);   // > 0 : dans le triangle
    const P = [], I = [], id = new Int32Array(NX * NY).fill(-1);
    for (let Y = 0; Y < NY; Y++) for (let X = 0; X < NX; X++) {
      const k = Y * NX + X, x = x0 + X * dx, y = y0 + Y * dy, e = edge(x, y);
      if (e < -dx || y < 0.755 || y > 0.975) continue;
      id[k] = P.length / 3;
      P.push(x, y, Hm[k] - 0.012 - 0.012 * (1 - sm(0, 0.03, e)) - 0.012 * (1 - sm(0.755, 0.79, y)));
    }
    for (let Y = 0; Y < NY - 1; Y++) for (let X = 0; X < NX - 1; X++) {
      const k = Y * NX + X, a = id[k], b = id[k + 1], c = id[k + NX], d = id[k + NX + 1];
      if (a >= 0 && b >= 0 && d >= 0) I.push(a, b, d);
      if (a >= 0 && d >= 0 && c >= 0) I.push(a, d, c);
    }
    const g = new THREE.BufferGeometry(); g.setAttribute('position', new THREE.Float32BufferAttribute(P, 3)); g.setIndex(I); g.computeVertexNormals();
    return g;
  }

  function bellyGeometry(skin) {
    const pos = skin.geometry.getAttribute('position');
    const NX = 41, NY = 51, x0 = -0.2, x1 = 0.2, y0 = 0.82, y1 = 1.3, dx = (x1 - x0) / (NX - 1), dy = (y1 - y0) / (NY - 1);
    const Hm = new Float32Array(NX * NY).fill(-1), fix = new Uint8Array(NX * NY);
    for (let i = 0; i < pos.count; i++) {
      const x = pos.getX(i), y = pos.getY(i), z = pos.getZ(i);
      if (z < 0 || x < x0 || x > x1 || y < y0 || y > y1) continue;
      const k = Math.round((y - y0) / dy) * NX + Math.round((x - x0) / dx);
      if (z > Hm[k]) Hm[k] = z;
    }
    for (let k = 0; k < Hm.length; k++) { if (Hm[k] > 0) fix[k] = 1; else Hm[k] = 0.06; }
    for (let it = 0; it < 300; it++) for (let Y = 1; Y < NY - 1; Y++) for (let X = 1; X < NX - 1; X++) { const k = Y * NX + X; if (!fix[k]) Hm[k] = 0.25 * (Hm[k - 1] + Hm[k + 1] + Hm[k - NX] + Hm[k + NX]); }
    for (let it = 0; it < 4; it++) { const c = Hm.slice(); for (let Y = 1; Y < NY - 1; Y++) for (let X = 1; X < NX - 1; X++) { const k = Y * NX + X; Hm[k] = (4 * c[k] + c[k - 1] + c[k + 1] + c[k - NX] + c[k + NX]) / 8; } }
    const hAt = (x, y) => {
      const fx = clamp((x - x0) / dx, 0, NX - 1.001), fy = clamp((y - y0) / dy, 0, NY - 1.001), X = Math.floor(fx), Y = Math.floor(fy), u = fx - X, v = fy - Y, k = Y * NX + X;
      return lerp(lerp(Hm[k], Hm[k + 1], u), lerp(Hm[k + NX], Hm[k + NX + 1], u), v);
    };
    const g2 = (v, w) => Math.exp(-(v * v) / (w * w));
    const relief = (x, y) => {
      const ax = Math.abs(x), yy = y - ax * 0.1;
      const inR = (1 - sm(0.07, 0.085, ax)) * sm(0.9, 0.95, y) * (1 - sm(1.19, 1.22, y));
      const B = [0.975, 1.035, 1.095, 1.15, 1.205]; let by = 0, r = 0;
      for (let k = 0; k < 4; k++) if (yy >= B[k] && yy < B[k + 1]) by = Math.sin(Math.PI * (yy - B[k]) / (B[k + 1] - B[k]));
      const bx = Math.sin(Math.PI * Math.min(1, ax / 0.078));
      r += 0.0045 * inR * Math.pow(bx, 0.6) * Math.pow(by, 0.6);
      r -= 0.0025 * g2(x, 0.007) * sm(0.93, 0.97, y) * (1 - sm(1.18, 1.21, y));
      r -= 0.0022 * (g2(yy - 1.15, 0.008) + g2(yy - 1.095, 0.008) + g2(yy - 1.035, 0.008)) * (1 - sm(0.06, 0.08, ax));
      r -= 0.003 * g2(ax - 0.082, 0.008) * sm(0.92, 0.97, y) * (1 - sm(1.16, 1.21, y));
      const nd = Math.hypot(x, (y - 1.012) / 1.3);
      r -= 0.009 * g2(nd, 0.0075); r += 0.0018 * g2(nd - 0.011, 0.004);
      r += 0.0025 * sm(0.085, 0.1, ax) * (0.7 + 0.3 * Math.sin((y + ax * 0.9) * 140));
      const vline = (ax - 0.03) - (y - 0.9) * 0.9;
      r -= 0 * g2(vline, 0.006) * (1 - sm(0.98, 1.0, y)) * sm(0.03, 0.05, ax);
      return r;
    };
    const RINGS = 64, SEG = 180, cy = 1.07, P = [], I = [];
    P.push(0, cy, hAt(0, cy) - 0.018 + relief(0, cy));
    for (let r = 1; r <= RINGS; r++) {
      const t = r / RINGS;
      for (let s2 = 0; s2 < SEG; s2++) {
        const a = s2 / SEG * TAU, ca = Math.cos(a), sa = Math.sin(a);
        const sy = Math.sign(sa) * Math.pow(Math.abs(sa), sa < 0 ? 0.4 : 0.7), sx = Math.sign(ca) * Math.pow(Math.abs(ca), 0.7);
        const y = cy + sy * (sa < 0 ? 0.1 : 0.15) * t, w = lerp(0.1, 0.115, sm(0.97, 1.17, y)), x = sx * w * t;
        P.push(x, y, hAt(x, y) - 0.018 - 0.016 * Math.pow(sm(0.6, 1, t), 2) + relief(x, y) * (1 - sm(0.8, 0.97, t)));
      }
    }
    for (let s2 = 0; s2 < SEG; s2++) I.push(0, 1 + s2, 1 + (s2 + 1) % SEG);
    for (let r = 1; r < RINGS; r++) for (let s2 = 0; s2 < SEG; s2++) { const a = 1 + (r - 1) * SEG + s2, b = 1 + (r - 1) * SEG + (s2 + 1) % SEG; I.push(a, a + SEG, b + SEG, a, b + SEG, b); }
    const bg = new THREE.BufferGeometry(); bg.setAttribute('position', new THREE.Float32BufferAttribute(P, 3)); bg.setIndex(I); bg.computeVertexNormals();
    return bg;
  }

  /* ---------- le parcours : une étape par section ----------
     zones : parties qui chauffent puis récupèrent ; zoom : 1 = corps entier ; rot : angle (0 = de face, π = de dos) */
  const PLAN = [
    { id: 'legs', zones: [1, 2], label: 'Jambes', focus: 0.62, zoom: 1.25, rot: 0.45, kw: ['jambe', 'cuisse', 'pressoth', 'botte', 'genou', 'pied', 'course', 'courir', 'benen', 'dijen', 'laarzen', 'knie', 'voeten', 'legs', 'thigh', 'boots', 'knee', 'running'] },
    { id: 'back', zones: [3], label: 'Dos', focus: 1.18, zoom: 2.1, rot: Math.PI + 0.35, kw: ['dos', 'lombaire', 'pistolet', 'percussion', 'rug', 'massagepistool', 'back', 'massage gun'] },
    { id: 'neck', zones: [4], label: 'Nuque & épaules', focus: 1.42, zoom: 2.5, rot: Math.PI - 0.5, kw: ['nuque', 'épaule', 'epaule', 'cervical', 'bureau', 'nek', 'schouder', 'neck', 'shoulder'] },
    { id: 'arms', zones: [5], label: 'Bras', focus: 1.12, zoom: 1.9, rot: 0.95, kw: ['bras', 'biceps', 'poignet', 'padel', 'tennis', 'raquette', 'armen', 'pols', 'arms', 'wrist'] },
    { id: 'core', zones: [6], label: 'Abdos & buste', focus: 1.1, zoom: 2.2, rot: -0.25, kw: ['abdo', 'ventre', 'poitrine', 'buste', 'gainage', 'buik', 'borst', 'chest', 'core'] },
    { id: 'calves', zones: [1], label: 'Mollets', focus: 0.38, zoom: 2.2, rot: Math.PI + 0.2, kw: ['mollet', 'cheville', 'foulée', 'foulee', 'kuit', 'enkel', 'calf', 'calves', 'ankle'] }
  ];
  const FULL = { id: 'full', zones: [0, 1, 2, 3, 4, 5, 6, 7], label: '', focus: 0.86, zoom: 1.0, rot: TAU - 0.3, full: true };
  // chaque section reçoit la partie du corps dont elle parle le plus (mots du texte) ; sinon la suivante pas encore montrée
  function pick(sec, used, prev) {
    const txt = (sec.innerText || '').toLowerCase();
    let best = null, bestN = 0;
    PLAN.forEach((pl) => {
      if (used.has(pl.id) || (prev && prev.id === pl.id)) return;
      let c = 0; pl.kw.forEach((w) => { let k = txt.indexOf(w); while (k >= 0) { c++; k = txt.indexOf(w, k + w.length); } });
      if (c > bestN) { bestN = c; best = pl; }
    });
    if (!best) best = PLAN.find((pl) => !used.has(pl.id) && (!prev || prev.id !== pl.id));
    if (!best) { used.clear(); best = PLAN.find((pl) => !prev || prev.id !== pl.id); }
    used.add(best.id);
    return best;
  }

  /* le petit rail sur le côté : toutes les parties du parcours, la partie en cours mise en avant */
  const rail = document.createElement('div');
  rail.setAttribute('aria-hidden', 'true');
  rail.style.cssText = "position:fixed;right:max(18px,env(safe-area-inset-right,0px));top:50%;transform:translateY(-50%);z-index:31;pointer-events:none;display:flex;flex-direction:column;gap:14px;align-items:flex-end;opacity:0;transition:opacity .4s;font:600 10px/1 'Inter',sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#1D2125";
  document.body.appendChild(rail);
  let railItems = [];
  function buildRail(list) {
    rail.innerHTML = ''; railItems = [];
    list.forEach((s) => {
      if (!s.label) return;
      const it = document.createElement('div');
      it.style.cssText = 'display:flex;align-items:center;gap:10px;transition:opacity .3s';
      it.innerHTML = '<span style="opacity:0;transform:translateX(6px);transition:opacity .3s,transform .3s"></span><i style="display:block;width:6px;height:6px;border-radius:50%;background:#8E979F;transition:transform .3s,background-color .3s"></i>';
      it.firstChild.textContent = L(s.label);
      rail.appendChild(it); railItems.push({ el: it, s });
    });
  }
  let stops = [], W = 1, H = 1, CW = 1, CH = 1;
  function sizeFor(m) {
    CW = m ? MW : W; CH = m ? MH : H;
    renderer.setSize(CW, CH, false); camera.aspect = CW / CH; camera.updateProjectionMatrix();
  }
  function setMode(m) {
    if (m === mini) return;
    mini = m; const op = cv.style.opacity;
    cv.style.cssText = m ? CSS_MINI : CSS_FULL; cv.style.opacity = op;
    if (m && dismissed) cv.style.transform = OFF;
    sizeFor(m);
  }
  function layout() {
    W = innerWidth; H = innerHeight;
    sizeFor(mini);
    const sy = scrollY, wide = W >= 900, list = [];
    const heroEnd = hero ? hero.getBoundingClientRect().bottom + sy : 0;
    list.push({ y: heroEnd - H * 0.5, zones: [0, 1, 2, 3, 4, 5, 6, 7], label: '', focus: 0.86, zoom: 1.0, rot: 0, side: 1, full: true });
    const secs = [...document.querySelectorAll('main .shopify-section, #MainContent > .shopify-section')].filter((s) => !s.contains(hero) && s.offsetHeight > 120);
    let n = 0; const used = new Set();
    secs.forEach((s) => {
      const r = s.getBoundingClientRect();
      if (r.top + sy < heroEnd - 10) return;
      const pl = n === 6 ? FULL : pick(s, used, list[list.length - 1]);
      list.push(Object.assign({ y: r.top + sy + Math.min(r.height, H) * 0.5, side: n % 2 ? -1 : 1 }, pl)); n++;
    });
    const er = endSec.getBoundingClientRect();
    list.push({ y: er.top + sy + H * 0.5, zones: [], label: '', focus: 0.86, zoom: 1.0, rot: TAU * Math.ceil(n / 2), side: 0, end: true, full: true });
    list.sort((a, b) => a.y - b.y);
    // les rotations s'enchaînent sans retour en arrière : le corps tourne toujours dans le même sens
    for (let k = 1; k < list.length; k++) { while (list[k].rot < list[k - 1].rot - 0.2) list[k].rot += TAU; }
    list.forEach((s) => { s.x = wide ? s.side * 0.27 : 0; });
    stops = list;
    if (wide) buildRail(list); else { rail.innerHTML = ''; railItems = []; }
  }
  layout();
  addEventListener('resize', layout);
  addEventListener('load', layout);
  setTimeout(layout, 1500); setTimeout(layout, 4000);
  if ('ResizeObserver' in window) new ResizeObserver(() => { clearTimeout(layout._t); layout._t = setTimeout(layout, 200); }).observe(document.body);

  /* ---------- boucle ---------- */
  let mx = 0, my = 0, tmx = 0, tmy = 0, sc = scrollY, alpha = 0;
  addEventListener('pointermove', (e) => { tmx = e.clientX / innerWidth * 2 - 1; tmy = e.clientY / innerHeight * 2 - 1; }, { passive: true });
  const t0 = performance.now(), v3 = new THREE.Vector3();
  const st = { x: 0, focus: 0.86, zoom: 1, rot: 0 }; let first = true, endAt = -1, fade = 1;

  function frame(now) {
    requestAnimationFrame(frame);
    if (document.hidden) return;
    const t = (now - t0) / 1000;
    sc += (scrollY - sc) * 0.12;
    let target = 1;
    if (heroTrack) { const b = heroTrack.getBoundingClientRect().bottom; target = sm(H * 0.95, H * 0.35, b); }
    alpha += (target - alpha) * 0.08;
    U.uOp.value = alpha * (small && !mini ? 0.85 : 1) * fade;
    if (alpha < 0.005 || !stops.length || !body.visible) { cv.style.opacity = '0'; if (phone) { setMode(true); fade = 1; } tag.style.opacity = '0'; rail.style.opacity = '0'; pull.style.display = 'none'; return; }
    cv.style.opacity = '1';

    const v = sc + H * 0.5;
    let i = 0; while (i < stops.length - 2 && v > stops[i + 1].y) i++;
    const s0 = stops[i], s1 = stops[i + 1] || s0;
    const raw = s1 === s0 ? 0 : clamp((v - s0.y) / (s1.y - s0.y), 0, 1);
    const m = sm(0.5, 0.9, raw);
    if (phone) {                                          // vers la fin, la carte s'efface et le corps revient en grand pour l'animation finale
      const wantFull = !!(s1.end && raw > 0.35);
      const dt = Math.min(0.1, t - (frame.lt || t)); frame.lt = t;
      if (wantFull !== !mini) { fade -= dt * 4; if (fade <= 0) { fade = 0; setMode(!wantFull); } }
      else fade = Math.min(1, fade + dt * 2.5);
      cv.style.opacity = String(fade > 0 ? 1 : 0);
    }                           // on reste sur la zone, puis on passe à la suivante

    // cadrage
    const tx = lerp(s0.x, s1.x, m), tf = lerp(s0.focus, s1.focus, m), tz = lerp(s0.zoom, s1.zoom, m), tr = lerp(s0.rot, s1.rot, m);
    if (first) { st.x = tx; st.focus = tf; st.zoom = tz; st.rot = tr; first = false; }
    st.x += (tx - st.x) * 0.1; st.focus += (tf - st.focus) * 0.1; st.zoom += (tz - st.zoom) * 0.1; st.rot += (tr - st.rot) * 0.1;
    const halfW = HALF_H * camera.aspect;
    // en plein écran, le corps entier occupe ~78 % de la hauteur ; on zoome autour de la zone travaillée
    const k = (2 * HALF_H * 0.78 / 1.72) * st.zoom * (small ? 0.78 : 0.8);
    body.scale.setScalar(k);
    body.rotation.y = st.rot + Math.sin(t * 0.4) * 0.04 + mx * 0.18;
    body.rotation.x = my * 0.05;
    body.position.set(st.x * halfW * 2, -st.focus * k + Math.sin(t * 0.8) * 0.005, 0);
    U.uInk.value = mini ? 2.6 : 1;
    if (mini) {                                             // dans la carte : le corps entier, de la tête aux pieds
      const km = 2 * HALF_H * 0.86 / 1.72;
      body.scale.setScalar(km); body.position.set(0, -0.86 * km, 0);
      body.rotation.y = st.rot + Math.sin(t * 0.4) * 0.06; body.rotation.x = 0;
    }
    if (s1.end && !mini) {                                  // à la fin : debout, de face, au-dessus du mot REKOVER
      const er = endSec.getBoundingClientRect(), e = phone ? 1 : sm(0.4, 0.95, raw);
      const feet = er.top + H * 0.66, hPx = Math.min(H * 0.56, W * 0.9), px2w = 2 * HALF_H / H;
      const kEnd = hPx * px2w / 1.72;
      body.scale.setScalar(lerp(k, kEnd, e));
      body.position.x = lerp(body.position.x, 0, e);
      body.position.y = lerp(body.position.y, (H / 2 - feet) * px2w, e);
      // arrivé en bas : petite animation, le corps se décompose, se recompose et redevient argent poli
      if (raw > 0.62 && endAt < 0) endAt = t;
      if (raw < 0.3) endAt = -1;
    } else if (endAt >= 0 && !s1.end) endAt = -1;
    const tau = endAt >= 0 ? (t - endAt) / 2.6 : 0;
    U.uEx.value = endAt >= 0 ? Math.sin(Math.PI * clamp(tau / 0.7, 0, 1)) : 0;
    U.uChrome.value = endAt >= 0 ? sm(0.55, 1.0, tau) : 0;
    if (endAt >= 0) body.rotation.y += Math.sin(Math.PI * clamp(tau / 0.7, 0, 1)) * 0.6;

    // la zone travaillée : rouge au début de la section, réparée par l'onde argentée au fil du scroll
    // la partie de la section devient argentée ; celle d'avant redevient un dessin pendant le passage
    if (phone) {
      // téléphone : le corps est rouge ; chaque partie montrée par une section devient argentée et le reste
      for (let z = 0; z < 8; z++) {
        let done = false;
        for (let k = 0; k <= i; k++) if (!stops[k].full && stops[k].zones.includes(z)) done = true;
        U.uS.value[z] = done ? 1 : (!s1.full && s1.zones.includes(z) ? m : 0);
        U.uHL.value[z] = s1.end && !mini ? 0 : 1;
      }
    } else {
      for (let z = 0; z < 8; z++) { U.uS.value[z] = Math.max(s0.zones.includes(z) ? 1 - m : 0, s1.zones.includes(z) ? m : 0); U.uHL.value[z] = 0; }
    }
    U.uT.value = t;

    // l'étiquette : pointe la zone, reliée par un trait
    const cur = m < 0.5 ? s0 : s1, show = !(phone && s1.end && !mini) && cur.label && Math.abs(m - (m < 0.5 ? 0 : 1)) < 0.35 && zoneC[cur.zones[0]];
    pull.style.display = mini && dismissed && alpha > 0.5 ? 'flex' : 'none';
    if (show && mini && !dismissed) {                                     // petite pastille au-dessus de la carte
      tagText.textContent = L(cur.label);
      tag.firstChild.style.display = 'none';
      tagText.style.padding = '6px 10px'; tagText.style.fontSize = '10px';
      const tw = tag.offsetWidth || 120, th = tag.offsetHeight || 24, r = cv.getBoundingClientRect();
      tag.style.transform = `translate(${Math.round(Math.max(12, r.right - tw))}px, ${Math.round(r.top - th - 8)}px)`;
      tag.style.opacity = String(alpha * fade);
    } else if (show && !mini) {
      tag.firstChild.style.display = ''; tagText.style.padding = ''; tagText.style.fontSize = '';
      const c = zoneC[cur.zones[0]];
      v3.set(c[0] * (cur.zones[0] === 5 ? 1 : 0.6), c[1], c[2]);
      body.updateMatrixWorld(); v3.applyMatrix4(body.matrixWorld).project(camera);
      const sx = (v3.x * 0.5 + 0.5) * W, sy2 = (-v3.y * 0.5 + 0.5) * H;
      const left = (cur.x || 0) <= 0;                      // l'étiquette part vers le centre de l'écran
      tagText.textContent = L(cur.label);
      tag.style.flexDirection = left ? 'row' : 'row-reverse';
      tag.firstChild.style.background = left ? 'linear-gradient(90deg,#1D2125,rgba(29,33,37,0))' : 'linear-gradient(90deg,rgba(29,33,37,0),#1D2125)';
      const tw = tag.offsetWidth || 160;
      const tx2 = clamp(left ? sx + 8 : sx - tw - 8, 12, W - tw - 12), ty2 = clamp(sy2 - 14, 80, H - 60);
      tag.style.transform = `translate(${Math.round(tx2)}px, ${Math.round(ty2)}px)`;
      tag.style.opacity = String(alpha * (small ? 0.9 : 1));
    } else tag.style.opacity = '0';

    // le rail : la partie en cours grossit et affiche son nom
    if (railItems.length) {
      rail.style.opacity = String(alpha * (s1.end && raw > 0.5 ? 0 : 0.9));
      railItems.forEach((r) => {
        const on = r.s === cur && cur.label;
        r.el.firstChild.style.opacity = on ? '1' : '0'; r.el.firstChild.style.transform = on ? 'none' : 'translateX(6px)';
        r.el.lastChild.style.transform = on ? 'scale(1.6)' : 'none'; r.el.lastChild.style.background = on ? '#1D2125' : '#8E979F';
      });
    }

    mx += (tmx - mx) * 0.05; my += (tmy - my) * 0.05;
    renderer.render(scene, camera);
  }
  requestAnimationFrame(frame);
})();
